import Menu from '../commom/Menu'
import ListMenu from '../commom/ListMenu'
import React, { useState } from 'react';
import IconTooltipButton from './IconTooltipButton';

const initialState = {
  mouseX: null,
  mouseY: null
};
const MenuIconButton = ({ id, items = [], icon, disabled, onClick, className, title, placement = 'top', ...props }) => {
  const [menu, setMenu] = useState(initialState)

  const handleMenuClose = () => setMenu(initialState)
  const handleMenuOpen = (event) => {
    setMenu({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
    if (onClick) {
      onClick()
    }
  };

  if (items.filter((item) => item.permissions).length === 0) {
    return <></>
  }

  return (
    <>
    <IconTooltipButton
      icon={icon}
      title={title}
      placement={placement}
      disabled={disabled}
      className={className}
      onClick={handleMenuOpen}
      {...props}
    />
    { items.filter((item) => item.permissions).length > 0 &&
      <Menu
        id={`menu-${id}`}
        MenuListProps={{
          style: { width: '260px' },
          className: "list-menu p-0"
        }}
        keepMounted
        open={menu.mouseY !== null}
        onClose={handleMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={
          menu.mouseY !== null && menu.mouseX !== null
            ? { top: menu.mouseY, left: menu.mouseX }
            : undefined
        }
      >
        <ListMenu 
          id={`menu-list-${id}`}
          items={items
            .filter((item) => item.permissions)
            .map((item) => ({ 
              ...item, 
              onClick: () => {
                if (item.onClick) {
                  item.onClick()
                }
                handleMenuClose()
              }
            }))
          } 
        />
      </Menu>   
    }
    </> 
  )


}
export default React.memo(MenuIconButton)
